<div class="map-container bg-white rounded-3 p-0">
  <input #searchBox (change)="handleAddressChange()" [class.is-invalid]="invalid" [placeholder]="placeholder" class="form-control mb-2" autocomplete="off" />
  @if (invalid) {
    <div class="invalid-feedback d-block mb-2">
      No pudimos identificar la calle de esta ubicación. Por favor, indique la dirección manualmente.
    </div>
  }
  @if(mapVisible()) {
    <google-map [center]="center" [mapId]="mapId" [options]="mapOptions" [zoom]="zoom" height="400px" width="100%"
      (mapClick)="onMapClick($event)">
      <map-advanced-marker (mapDragend)="onMarkerDragEnd($event)" [gmpDraggable]="draggable" [position]="center" />
    </google-map>
    <p class="text-muted small mt-2 mb-0 d-flex align-items-center gap-1">
      <span class="material-symbols-outlined" style="font-size:16px">drag_pan</span>
      Haz clic en el mapa o arrastra el marcador para ajustar la ubicación exacta
    </p>
  } @else {
    <div class="d-flex align-items-center justify-content-center rounded-3 border text-muted bg-light" style="height:180px; border-style:dashed !important;">
      <div class="text-center">
        <span class="material-symbols-outlined d-block mb-1 text-colonial" style="font-size:2.5rem;">location_searching</span>
        <small>Escriba y seleccione una dirección para ver el mapa</small>
      </div>
    </div>
  }
</div>
